module.exports = __webpack_public_path__ + "img/error.17cb5185.svg";